import Lenis from "lenis";

export const lenis = new Lenis({
  lerp: 0.09,
  smoothWheel: true,
});
